import { ReactNode } from 'react'

export interface MainLayoutProps {
  children: ReactNode
}

export const MainLayout = ({ children }: MainLayoutProps) => {
  return (
    <div className="min-h-screen bg-background text-text">
      <header className="px-3 sm:px-4 pt-3 sm:pt-4 pb-2 border-b border-border sticky top-0 z-50 bg-background/95 backdrop-blur-sm">
        <h1 className="text-xl sm:text-2xl md:text-3xl font-bold">PeriScope</h1>
        <p className="text-xs sm:text-sm text-text-muted mt-0.5 sm:mt-1">Location-Based Audio Narration</p>
      </header>
      <main className="p-3 sm:p-4 md:p-6 grid gap-3 sm:gap-4 max-w-[1400px] mx-auto" role="main">
        {children}
      </main>
    </div>
  )
}
